// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevRepreController {
	/* @ngInject */
	constructor() {
		this.data = [
			{
				lang: {
					kid: 'K_NODE;UNIVERSEL',
					isa: 'K_NODE;SYS_CLASSE',
					isa_name: 'CLASSE',
					name: 'Universel',
				},
				type: 'K_NODE;STRING',
				name: 'test1',
				readOnly: false,
			},
		];

		this.jsonEditorOptions = {
			mode:  'code',
			modes: [
				'code',
				'form',
				'text',
				'tree',
				'view',
			],
		};

		this.settings = {
			validate: {
				rules:                {
					'K_NODE;UNIV_LANG': {
						required: true,
					},
					'K_NODE;SQL':       {
						pattern:  '[a-z][a-z0-9_]*',
						required: true,
					},
				},
			},
			add:      true,
			insert:   true,
		};

		this.myForm = {};
		this.readOnly = false;
		this.add = true;
		this.readOnly = false;
	}
}
